export const dcaManagerAbi = [
  {
    inputs: [],
    name: 'DcaManager__PurchasePeriodMustBeGreaterThanMinimum',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DcaManager__DepositAmountMustBeGreaterThanZero',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DcaManager__InexistentScheduleIndex',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'DcaManager__MaxSchedulesPerTokenReached',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'minPurchaseAmount', type: 'uint256' },
    ],
    name: 'DcaManager__PurchaseAmountMustBeGreaterThanMinimum',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DcaManager__PurchaseAmountMustBeLowerThanHalfOfBalance',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
      { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'remainingBalance', type: 'uint256' },
    ],
    name: 'DcaManager__ScheduleBalanceNotEnoughForPurchase',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DcaManager__ScheduleIdAndIndexMismatch',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'DcaManager__TokenDoesNotYieldInterest',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'lendingProtocolIndex', type: 'uint256' },
    ],
    name: 'DcaManager__TokenNotAccepted',
    type: 'error',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint256', name: 'balance', type: 'uint256' },
    ],
    name: 'DcaManager__WithdrawalAmountExceedsBalance',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DcaManager__WithdrawalAmountMustBeGreaterThanZero',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: true, internalType: 'address', name: 'token', type: 'address' },
      { indexed: true, internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
      { indexed: false, internalType: 'uint256', name: 'depositAmount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'purchaseAmount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'purchasePeriod', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'lendingProtocolIndex', type: 'uint256' },
    ],
    name: 'DcaManager__DcaScheduleCreated',
    type: 'event',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'depositAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'purchaseAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'purchasePeriod', type: 'uint256' },
      { internalType: 'uint256', name: 'lendingProtocolIndex', type: 'uint256' },
    ],
    name: 'createDcaSchedule',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
      { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
    ],
    name: 'deleteDcaSchedule',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
      { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
      { internalType: 'uint256', name: 'depositAmount', type: 'uint256' },
    ],
    name: 'depositToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getDefaultMinPurchaseAmount',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getMaxSchedulesPerToken',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getMinPurchasePeriod',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getOperationsAdminAddress',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'getMyDcaSchedules',
    outputs: [
      {
        components: [
          { internalType: 'uint256', name: 'tokenBalance', type: 'uint256' },
          { internalType: 'uint256', name: 'purchaseAmount', type: 'uint256' },
          { internalType: 'uint256', name: 'purchasePeriod', type: 'uint256' },
          { internalType: 'uint256', name: 'lastPurchaseTimestamp', type: 'uint256' },
          { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
          { internalType: 'uint256', name: 'lendingProtocolIndex', type: 'uint256' },
        ],
        internalType: 'struct IDcaManager.DcaDetails[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'lendingProtocolIndex', type: 'uint256' },
    ],
    name: 'getMyInterestAccrued',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
    ],
    name: 'getMyScheduleId',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'getTokenMinPurchaseAmount',
    outputs: [
      { internalType: 'uint256', name: 'minPurchaseAmount', type: 'uint256' },
      { internalType: 'bool', name: 'customMinAmountSet', type: 'bool' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
      { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
      { internalType: 'uint256', name: 'purchaseAmount', type: 'uint256' },
    ],
    name: 'setPurchaseAmount',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
      { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
      { internalType: 'uint256', name: 'purchasePeriod', type: 'uint256' },
    ],
    name: 'setPurchasePeriod',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address[]', name: 'tokens', type: 'address[]' },
      { internalType: 'uint256[]', name: 'lendingProtocolIndexes', type: 'uint256[]' },
    ],
    name: 'withdrawAllAccumulatedInterest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address[]', name: 'tokens', type: 'address[]' },
      { internalType: 'uint256[]', name: 'lendingProtocolIndexes', type: 'uint256[]' },
    ],
    name: 'withdrawAllAccumulatedRbtc',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'lendingProtocolIndex', type: 'uint256' },
    ],
    name: 'withdrawRbtcFromTokenHandler',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
      { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
      { internalType: 'uint256', name: 'withdrawalAmount', type: 'uint256' },
    ],
    name: 'withdrawToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'token', type: 'address' },
      { internalType: 'uint256', name: 'scheduleIndex', type: 'uint256' },
      { internalType: 'bytes32', name: 'scheduleId', type: 'bytes32' },
      { internalType: 'uint256', name: 'withdrawalAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'lendingProtocolIndex', type: 'uint256' },
    ],
    name: 'withdrawTokenAndInterest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
